const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const interviewLocationList = () =>
  import("../views/interview-location/interviewLocationList.vue");
const interviewLocationPlanList = () =>
  import("../views/interview-location-plan/interviewLocationPlanList.vue");
const interviewAccepting = () =>
  import("../views/interview-accepting/interviewAccepting.vue");
const interviewDoing = () =>
  import("../views/interview-doing/interviewDoing.vue");
const interviewDoneList = () =>
  import("../views/interview-done/interviewDoneList.vue");
const interviewPlaningShowList = () =>
  import("../views/interview-planing-show/interviewPlaningShowList.vue");
const interviewReadyList = () =>
  import("../views/interview-ready/interviewReadyList.vue");

export const interviewRoutes: any[] = [
  {
    path: "/interview",
    name: "interview",
    meta: {
      label: "خانه",
      moduleName: "interview",
    },
    component: newContainer,
    children: [
      {
        path: "interview_v_help",
        name: "interview_v_help",
        // component: interviewVhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "interview_k_help",
        name: "interview_k_help",
        // component: interviewKhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "interview_m_help",
        name: "interview_m_help",
        // component: interviewMhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "interview_p_help",
        name: "interview_p_help",
        // component: interviewPhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "question-suggest",
        name: "question-suggestion",
        redirect: "/interview/question-suggest/list",
        // component: routerParrent,
        meta: {
          label: "سؤال‌ها",
          requiresAuth: true,
        },
        children: [
          {
            path: "list",
            name: "question_suggestion",
            // component: searchQuestionSuggest,
            meta: {
              label: "سؤال‌های پیشنهادی",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:id",
            name: "edit_question_suggest",
            // component: editQuestionSuggest,
            meta: {
              label: "ویرایش مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-question-suggest",
        name: "my-question-suggestion",
        redirect: "/interview/my-question-suggest/list",
        // component: routerParrent,
        meta: {
          label: "سؤال‌ها",
          requiresAuth: true,
        },
        children: [
          {
            path: "list",
            name: "my_question_suggestion",
            // component: searchQuestionSuggest,
            meta: {
              label: "سؤال‌های پیشنهادی من",
              requiresAuth: true,
            },
          },
        ],
      },
      // {
      //   path: "interviewLocationPlan",
      //   name: "interview_location_plan",
      //   redirect: "/interview/interviewLocationPlan/search",
      //   // component: routerParrent,
      //   meta: {
      //     label: "مصاحبه",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "search",
      //       // component: searchInterviewLocationPlan,
      //       meta: {
      //         label: "زمانبندی و تعیین ظرفیت مکان‌های مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //     {
      //       path: "placeLocationPlan/:id",
      //       name: "placeIninterviewLocationPlan",
      //       // component: placeIninterviewLocationPlan,
      //       meta: {
      //         label: "ظرفیت مکان‌های مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //     {
      //       path: "interviewLocationAudience/:id",
      //       name: "interviewLocationAudience",
      //       // component: searchInterviewLocationAudience,
      //       meta: {
      //         label: "تعیین متقاضی مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //     {
      //       path: "InterviewLocationPerson/:id",
      //       name: "searchInterviewLocationPerson",
      //       // component: searchInterviewLocationPerson,
      //       meta: {
      //         label: "تعیین استاد مصاحبه برای مکان/زمان",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      {
        path: "interviewSeniorMaster",
        name: "interviewSeniorMaster",
        redirect: "/interview/interviewSeniorMaster/search",
        // component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchInterviewSeniorMaster",
            // component: searchInterviewSeniorMaster,
            meta: {
              label: "رابطه بین استاد ارشد مصاحبه و استاد مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      // {
      //   path: "interviewDoing",
      //   name: "interview_doing",
      //   redirect: "/interview/interviewDoing/search",
      //   // component: routerParrent,
      //   meta: {
      //     label: "مصاحبه",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "searchInterviewDoing",
      //       // component: searchInterviewDoing,
      //       meta: {
      //         label: "انجام مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: "interviewAccepting",
      //   name: "interview_accepting",
      //   redirect: "/interview/InterviewAccepting/search",
      //   // component: routerParrent,
      //   meta: {
      //     label: "مصاحبه",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "searchInterviewAccepting",
      //       // component: searchInterviewAccepting,
      //       meta: {
      //         label: "پذیرش مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: "interviewReady",
      //   name: "interview_ready",
      //   redirect: "/interview/interviewReady/search",
      //   component: routerParrent,
      //   meta: {
      //     label: "مصاحبه ",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "searchInterviewReady",
      //       component: searchInterviewReady,
      //       meta: {
      //         label: "آماده مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: "InterviewPlaningShow",
      //   name: "interview_planing_show",
      //   redirect: "/interview/InterviewPlaningShow/search",
      //   component: routerParrent,
      //   meta: {
      //     label: "مصاحبه",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "searchInterviewPlaningShow",
      //       component: searchInterviewPlaningShow,
      //       meta: {
      //         label: "مشاهده زمان مصاحبه",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      {
        path: "scheduleInterviewLocation",
        name: "schedule_interview_location",
        redirect: "/interview/scheduleInterviewLocation/search",
        // component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchScheduleInterviewLocation",
            // component: searchScheduleInterviewLocation,
            meta: {
              label: " زمان مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      // {
      //   path: "interviewDone",
      //   name: "interview_done",
      //   redirect: "/interview/interviewDone/search",
      //   // component: routerParrent,
      //   meta: {
      //     label: "مصاحبه",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "searchInterviewDone",
      //       // component: searchInterviewDone,
      //       meta: {
      //         label: "مصاحبه‌های انجام شده",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      {
        path: "",
        name: "interview_report_card_parent",
        redirect: "/interview/reportCard",
        // component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "reportCard",
            name: "interview_report_card",
            // component: reportCard,
            meta: {
              label: "مشاهده کارنامه آزمون شفاهی",
              requiresAuth: true,
            },
          },
          {
            path: "reportCard/:code",
            name: "interview_final_result",
            // component: reportCard,
            meta: {
              label: "مشاهده کارنامه آزمون شفاهی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "interview-location",
        name: "interview_location",
        component: routerParent,
        redirect: "/interview/interview-location/list",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "interview-location-list",
            component: interviewLocationList,
            meta: {
              label: "مکان‌های مصاحبه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "interview-location-plan",
        name: "interview_location_plan",
        component: routerParent,
        redirect: "/interview/interview-location-plan/list",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "interview-location-plan-list",
            component: interviewLocationPlanList,
            meta: {
              label: "زمانبندی مصاحبه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "interview-accepting",
        name: "interview_accepting",
        component: routerParent,
        redirect: "/interview/interview-accepting/search",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
        children: [
          {
            path: "search",
            name: "interview-accepting-search",
            component: interviewAccepting,
            meta: {
              label: "پذیرش مصاحبه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "interview-doing",
        name: "interview_doing",
        component: routerParent,
        redirect: "/interview/interview-doing/search",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
          hasBottomNavigation: false,
        },
        children: [
          {
            path: "search",
            name: "interview-doing-search",
            component: interviewDoing,
            meta: {
              label: "انجام مصاحبه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "interview-done",
        name: "interview_done",
        component: routerParent,
        redirect: "/interview/interview-done/list",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "interview-done-list",
            component: interviewDoneList,
            meta: {
              label: "مصاحبه‌های انجام شده",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "interview-planing-show",
        name: "interview_planing_show",
        component: routerParent,
        redirect: "/interview/interview-planing-show/list",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "interview-planing-show-list",
            component: interviewPlaningShowList,
            meta: {
              label: "مصاحبه‌های من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "interview-ready",
        name: "interview_ready",
        component: routerParent,
        redirect: "/interview/interview-ready/list",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "interview-ready-list",
            component: interviewReadyList,
            meta: {
              label: "آماده مصاحبه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
];
